/**
 * @file index.tsx
 *
 * @fileoverview This is the registration page and is accessed by going to "/user/register".
 * The page displays a form for the user to provide his register information and on submit
 * will make a call to register the user.
 */

import React from 'react';
import { Register } from '~/jobiqo/components/User/Register';
import { GdprConsentProvider } from '~/jobiqo/components/GDPRConsent/hooks/useGdprConsentContext';
import { GetServerSideProps, NextPage } from 'next';
import { withAuthenticateAnonymous } from '~/jobiqo/hocs/withAuthenticate/anonymous';
import { getServerFrontendConfig } from '~/jobiqo/lib/frontendConfig';
import { gsspRedirect } from '~/jobiqo/lib/redirect';

const RegisterPage: NextPage = () => (
  <GdprConsentProvider>
    <Register />
  </GdprConsentProvider>
);

export const getServerSideProps: GetServerSideProps = withAuthenticateAnonymous(
  {
    gssp: async (ctx) => {
      const frontendConfig = getServerFrontendConfig();
      const APPLICANT_FEATURE_ACTIVE =
        frontendConfig.RESUME.APPLICANT_FEATURE_ACTIVE;
      const RECRUITER_FEATURE_ACTIVE =
        frontendConfig.ORGANIZATIONS.RECRUITER_FEATURE_ACTIVE;

      // Redirect to the home page if both features are inactive.
      if (!APPLICANT_FEATURE_ACTIVE && !RECRUITER_FEATURE_ACTIVE) {
        return {
          props: {},
          redirect: {
            destination: gsspRedirect(ctx, '/'),
            permanent: false,
          },
        };
      }

      const roles = {
        applicant: 'applicant',
        recruiter: 'recruiter',
      };

      const urlPath = ctx.resolvedUrl.split('?')[0];
      let urlRole = '';
      [roles.applicant, roles.recruiter].forEach((role) => {
        if (urlPath.endsWith(role)) {
          urlRole = role;
        }
      });

      return {
        props: {},
        ...(urlRole === roles.applicant &&
          !APPLICANT_FEATURE_ACTIVE && {
            redirect: {
              destination: '/404',
            },
          }),
      };
    },
  },
);

export default RegisterPage;
